<template>
  <div class="header">
    <div class="header-logo" @click="routerVisualization()">
      <img src="../../assets/imgs/title.png" alt />
      <!-- <span style="margin-left:20px">负荷精细化管控</span> -->
    </div>
    <div class="header-operation">
      <div class="header-user">
        <img src="../../assets/imgs/avatar.png" alt />
        <span>欢迎您, {{ $store.state.app.userInfo.userName }}</span>
      </div>
      <!-- <div class="header-theme">
        <span class="header-theme-title">主题颜色</span>
        <el-color-picker
          class="header-theme-picker"
          popper-class="header-theme-picker-self"
          v-model="theme"
          size="mini"
          @change="colorChangeHandler"
        ></el-color-picker>
      </div>-->
      <div class="header-logout" @click="logoutHandler">退出登录</div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { removeToken } from "@/utils/auth";
import { getSession, removeSession } from "@/utils/session";
import { logout } from "@/api/app";
export default {
  name: "Header",
  data() {
    return {
      theme: store.state.app.themeColor,
    };
  },
  methods: {
    colorChangeHandler(e) {
      store.commit("app/TOGGLE_THEME", e);
    },
    logoutHandler() {
      this.$store.state.app.userInfo.userName='';
      removeToken();
      removeSession("userInfo");
      try {
        logout({ userName: getSession("userInfo").userName });
      } catch (error) {}
      store.commit("app/LOGOUT");
      this.$router.push("/login");
    },
    routerVisualization() {
      const newe = this.$router.resolve({
        path: `/visualization`,
      });
      window.open(newe.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  .header-logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 320px;
    height: 80px;
    font-size: 22px;
    img {
      width: 300px;
    }
  }
  .header-operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-user {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 10px;
      img {
        height: 40px;
      }
      span {
        display: inline-block;
        padding: 0 20px;
        width: 80px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .header-theme,
    .header-logout {
      display: inline-block;
      margin: 0 10px;
      padding: 0 10px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 14px;
      border: 1px solid #fff;
      .header-theme-title {
        vertical-align: middle;
      }
      // .header-theme-picker {
      //   vertical-align: middle;
      //   // border: none;
      //   /deep/ .el-color-picker__trigger {
      //     border: none;
      //   }
      //   /deep/ .el-color-picker__color {
      //     border: 1px solid #fff;
      //   }
      // }
    }
    .header-logout {
      cursor: pointer;
    }
  }
}
</style>